import { useEffect } from 'react';

import { useLazyQuery } from '@apollo/client/react';
import { getDefaultStore, useAtomValue, useSetAtom } from 'jotai';

import {
  allCountryLabelsAtom,
  allCountryLabelsErrorAtom,
  allCountryLabelsLoadingAtom,
} from '../../states/country-labels.state';
import { GetAllCountryLabelsDocument } from '../graphql/generated/graphql';

export function useGetAllCountryLabels() {
  const setCountryLabels = useSetAtom(allCountryLabelsAtom);
  const setLoading = useSetAtom(allCountryLabelsLoadingAtom);
  const setError = useSetAtom(allCountryLabelsErrorAtom);
  const countryLabels = useAtomValue(allCountryLabelsAtom);
  const loading = useAtomValue(allCountryLabelsLoadingAtom);
  const error = useAtomValue(allCountryLabelsErrorAtom);

  const [executeFetch, { data, loading: queryLoading, error: queryError }] =
    useLazyQuery(GetAllCountryLabelsDocument, { fetchPolicy: 'no-cache' });

  useEffect(() => {
    const store = getDefaultStore();
    if (store.get(allCountryLabelsAtom).length > 0) return;
    if (store.get(allCountryLabelsLoadingAtom)) return;
    void executeFetch();
  }, [executeFetch]);

  useEffect(() => {
    if (data?.allCountryLabels) {
      setCountryLabels(data.allCountryLabels);
      setError(undefined);
      setLoading(false);
    }
  }, [data, setCountryLabels, setError, setLoading]);

  useEffect(() => {
    if (queryLoading) setLoading(true);
  }, [queryLoading, setLoading]);

  useEffect(() => {
    if (queryError) {
      setError(queryError);
      setLoading(false);
    }
  }, [queryError, setError, setLoading]);

  return { countryLabels, loading, error };
}
